export const ROUTE_PATH = '/help/clean' as const
